import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  IconButton,
  Tooltip,
  Input
} from '@material-ui/core';
import CheckIcon from "@material-ui/icons/Check";
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const NameInput = ({ classes, name, isViewName, invertColor, onSave, charLimit = 1000 }) => {
  const [myName, setMyName] = useState(name);
  const [nameError, setNameError] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current && inputRef.current.focus();
  }, []);

  const onEditNameBlur = e => {
    if (nameError?.length) return;
    onSave(myName.trim());
  }

  const onInputChange = e => {
    const maxLength = charLimit;
    const trimmedValue = e.target.value.trim();
    if (!trimmedValue.length && !nameError) {
      setNameError(`Name is required`);
    } else if (trimmedValue.length > maxLength && !nameError) {
      setNameError(`Length must be ${maxLength} characters or less`);
    } else if (nameError?.length && trimmedValue.length && trimmedValue.length <= maxLength) {
      setNameError('');
    }
    setMyName(e.target.value);
  }

  const handleRenameSave = e => {
    onSave(myName.trim());
  }
  const hasError = nameError.length > 0;
  return (
    <>
      <Tooltip title={hasError ? nameError : ''}>
        <Input
          // color='secondary'
          inputRef={inputRef}
          value={myName}
          margin='dense'
          classes={{ root: classNames(classes.editNameInputRoot, invertColor && classes.invertedColors), input: classes.editNameInput }}
          // autoFocus={true}
          onBlur={onEditNameBlur}
          onChange={onInputChange}
          style={{ fontSize: isViewName ? '1.2rem' : '.875rem'}}
          error={hasError}
        />
      </Tooltip>
      <IconButton
        color='inherit'
        className={classes.moreButton}
        onClick={handleRenameSave}
        disabled={hasError}
      >
        <CheckIcon />
      </IconButton>
    </>
  )
}

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    padding: '2px 4px',
    backgroundColor: '#cbcbcb',
    borderBottom: '1px solid #b7b7b7',
    
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    // margin: '8px 0',
  },
  headerRight: {
    display: 'flex'
  },
  openedList: {
    paddingTop: 8,
    paddingBottom: 8,
    backgroundColor: '#f2f2f2',
    transition: 'background-color 0.2 ease',
    overflowY: 'auto',
    borderBottom: '1px solid #b7b7b7'
  },
  expandButton: {
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    padding: 2,
    marginRight: 6
  },
  visibilityButton: {
    padding: 2
  },
  moreButton: {
    padding: 2,
    marginLeft: 6
  },
  editNameInputRoot: {
    color: 'inherit',
    fontWeight: 500,
    width: 250,
    '& .MuiInput-underline': {
      marginLeft: 2,
    },
  },
  editNameInput: {
    paddingBottom: 4
  },
  invertedColors: {
    '&::before': {
      borderBottomColor: 'rgba(255, 255, 255, 0.55)',
    },
    '&:hover:not(.Mui-disabled):before': {
      borderBottomColor: 'rgba(255, 255, 255, 0.55)',
    },
    '&::after': {
      borderBottomColor: 'rgba(255, 255, 255, 0.7)',
    }
  }
}

const mapStateToProps = state => {
  const { exploreViews } =  state;

  return {
    selectedView: exploreViews.selectedView
  }
};

const mapDispatchToProps = {

};

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(NameInput);
